// src/features/records/components/MapView/hooks/useGeolocation.js
import { useState, useEffect } from 'react';
import { logInfo, ErrorCategory } from '../../../../../services/errorService';

const useGeolocation = () => {
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!navigator.geolocation) {
      const errorMessage = 'Geolocation is not supported by your browser';
      setError(errorMessage);
      setLoading(false);
      
      // Log as info since this is a browser limitation, not an error
      logInfo(errorMessage, {
        category: ErrorCategory.PERMISSION,
        component: 'useGeolocation',
        action: 'checkSupport'
      });
      
      return;
    }

    const options = {
      timeout: 5000,
      enableHighAccuracy: false, // Don't need high accuracy for initial viewport
      maximumAge: 300000 // Cache for 5 minutes
    };

    const onSuccess = (position) => {
      setLocation({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy
      });
      setLoading(false);
    };

    const onError = (err) => {
      console.warn('Geolocation error:', err);
      setError(err.message);
      setLoading(false);
      
      // Log geolocation errors as info since they're often user permissions
      logInfo(`Geolocation error: ${err.message}`, {
        category: ErrorCategory.PERMISSION,
        component: 'useGeolocation',
        action: 'getCurrentPosition',
        metadata: {
          errorCode: err.code,
          errorMessage: err.message
        }
      });
    };

    // Get current position
    navigator.geolocation.getCurrentPosition(onSuccess, onError, options);

    // Optional: Watch position for updates
    // const watchId = navigator.geolocation.watchPosition(onSuccess, onError, options);
    // return () => navigator.geolocation.clearWatch(watchId);

  }, []);

  return { location, loading, error };
};

export default useGeolocation;